import { render, staticRenderFns } from "./IntegrationStatusIndicator.vue?vue&type=template&id=5f48f034"
import script from "./IntegrationStatusIndicator.vue?vue&type=script&lang=js"
export * from "./IntegrationStatusIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports